module.exports = __webpack_public_path__ + "images/40367b20045093a4f04ee81de835204f.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/love-ukraine.png
// module id = 326
// module chunks = 24